import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const navigation = [
  { label: 'Over gezinszorg', href: 'https://niegewoon.be/over-gezinszorg/' },
  { label: 'Verhalen', href: 'https://niegewoon.be/verhalen/' },
  { label: 'Voor professionals', href: 'https://niegewoon.be/voor-professionals/' }
];

function QuizShell({ children, screen = 'quiz' }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <main className={`quiz-experience quiz-experience--${screen}`}>
      <header className="campaign-header">
        <div className="campaign-nav">
          <a
            className="campaign-logo"
            href="https://niegewoon.be/"
            aria-label="Ga naar de homepagina van Niegewoon"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1788597613645-image.png"
              alt="Gezinszorg, da's niegewoon"
            />
          </a>

          <button
            type="button"
            className="menu-toggle"
            aria-label={menuOpen ? 'Menu sluiten' : 'Menu openen'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <SafeIcon icon={menuOpen ? FiX : FiMenu} aria-hidden="true" />
          </button>

          <nav className={`campaign-links ${menuOpen ? 'campaign-links--open' : ''}`}>
            {navigation.map((item) => (
              <a key={item.label} href={item.href}>
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <div className="decor decor--coral" aria-hidden="true" />
      <div className="decor decor--yellow" aria-hidden="true" />
      <div className="decor decor--blue" aria-hidden="true" />

      <motion.section
        className="quiz-shell"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
      >
        {children}
      </motion.section>
    </main>
  );
}

export default QuizShell;